import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import it from "./locales/it.json";
import pt from "./locales/pt.json";
import en from "./locales/en.json";

i18n
  .use(initReactI18next) // initialize i18next with React
  .use(LanguageDetector)  // automatically detect language
  .init({
    resources: {
      it: { translation: it },
      pt: { translation: pt },
      en: { translation: en }
    },
    fallbackLng: "en", // default
    interpolation: { escapeValue: false }, // Disable security escaping for React, to correctly interpret the html code in translations
    detection: { // #POW-37
      // detection setup
      order: ["localStorage", "cookie", "navigator"], // detect from browser language
      caches: ["localStorage", "cookie"], // save the chosen language
    },
  });

export default i18n;